/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AskRouteImport } from './routes/ask'
import { Route as AdminAnalyticsRouteImport } from './routes/admin/analytics'
import { Route as AdminTagsRouteImport } from './routes/admin/tags'
import { Route as AdminUsersRouteImport } from './routes/admin/users'
import { Route as LibraryIndexRouteImport } from './routes/library/index'
import { Route as LibraryDocumentIdRouteImport } from './routes/library/$documentId'
import { Route as QuestionsIndexRouteImport } from './routes/questions/index'
import { Route as QuestionsQuestionIdRouteImport } from './routes/questions/$questionId'
import { Route as StaffExtractionIndexRouteImport } from './routes/staff/extraction/index'
import { Route as StaffExtractionPartnerIdRouteImport } from './routes/staff/extraction/$partnerId'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AskRoute = AskRouteImport.update({
  id: '/ask',
  path: '/ask',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminAnalyticsRoute = AdminAnalyticsRouteImport.update({
  id: '/admin/analytics',
  path: '/admin/analytics',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminTagsRoute = AdminTagsRouteImport.update({
  id: '/admin/tags',
  path: '/admin/tags',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/admin/users',
  path: '/admin/users',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraryIndexRoute = LibraryIndexRouteImport.update({
  id: '/library/',
  path: '/library/',
  getParentRoute: () => rootRouteImport,
} as any)
const LibraryDocumentIdRoute = LibraryDocumentIdRouteImport.update({
  id: '/library/$documentId',
  path: '/library/$documentId',
  getParentRoute: () => rootRouteImport,
} as any)
const QuestionsIndexRoute = QuestionsIndexRouteImport.update({
  id: '/questions/',
  path: '/questions/',
  getParentRoute: () => rootRouteImport,
} as any)
const QuestionsQuestionIdRoute = QuestionsQuestionIdRouteImport.update({
  id: '/questions/$questionId',
  path: '/questions/$questionId',
  getParentRoute: () => rootRouteImport,
} as any)
const StaffExtractionIndexRoute = StaffExtractionIndexRouteImport.update({
  id: '/staff/extraction/',
  path: '/staff/extraction/',
  getParentRoute: () => rootRouteImport,
} as any)
const StaffExtractionPartnerIdRoute =
  StaffExtractionPartnerIdRouteImport.update({
    id: '/staff/extraction/$partnerId',
    path: '/staff/extraction/$partnerId',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/ask': typeof AskRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/tags': typeof AdminTagsRoute
  '/admin/users': typeof AdminUsersRoute
  '/library/$documentId': typeof LibraryDocumentIdRoute
  '/questions/$questionId': typeof QuestionsQuestionIdRoute
  '/library/': typeof LibraryIndexRoute
  '/questions/': typeof QuestionsIndexRoute
  '/staff/extraction/$partnerId': typeof StaffExtractionPartnerIdRoute
  '/staff/extraction/': typeof StaffExtractionIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/ask': typeof AskRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/tags': typeof AdminTagsRoute
  '/admin/users': typeof AdminUsersRoute
  '/library/$documentId': typeof LibraryDocumentIdRoute
  '/questions/$questionId': typeof QuestionsQuestionIdRoute
  '/library': typeof LibraryIndexRoute
  '/questions': typeof QuestionsIndexRoute
  '/staff/extraction/$partnerId': typeof StaffExtractionPartnerIdRoute
  '/staff/extraction': typeof StaffExtractionIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/ask': typeof AskRoute
  '/admin/analytics': typeof AdminAnalyticsRoute
  '/admin/tags': typeof AdminTagsRoute
  '/admin/users': typeof AdminUsersRoute
  '/library/$documentId': typeof LibraryDocumentIdRoute
  '/questions/$questionId': typeof QuestionsQuestionIdRoute
  '/library/': typeof LibraryIndexRoute
  '/questions/': typeof QuestionsIndexRoute
  '/staff/extraction/$partnerId': typeof StaffExtractionPartnerIdRoute
  '/staff/extraction/': typeof StaffExtractionIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/ask'
    | '/admin/analytics'
    | '/admin/tags'
    | '/admin/users'
    | '/library/$documentId'
    | '/questions/$questionId'
    | '/library/'
    | '/questions/'
    | '/staff/extraction/$partnerId'
    | '/staff/extraction/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/ask'
    | '/admin/analytics'
    | '/admin/tags'
    | '/admin/users'
    | '/library/$documentId'
    | '/questions/$questionId'
    | '/library'
    | '/questions'
    | '/staff/extraction/$partnerId'
    | '/staff/extraction'
  id:
    | '__root__'
    | '/'
    | '/ask'
    | '/admin/analytics'
    | '/admin/tags'
    | '/admin/users'
    | '/library/$documentId'
    | '/questions/$questionId'
    | '/library/'
    | '/questions/'
    | '/staff/extraction/$partnerId'
    | '/staff/extraction/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AskRoute: typeof AskRoute
  AdminAnalyticsRoute: typeof AdminAnalyticsRoute
  AdminTagsRoute: typeof AdminTagsRoute
  AdminUsersRoute: typeof AdminUsersRoute
  LibraryDocumentIdRoute: typeof LibraryDocumentIdRoute
  QuestionsQuestionIdRoute: typeof QuestionsQuestionIdRoute
  LibraryIndexRoute: typeof LibraryIndexRoute
  QuestionsIndexRoute: typeof QuestionsIndexRoute
  StaffExtractionPartnerIdRoute: typeof StaffExtractionPartnerIdRoute
  StaffExtractionIndexRoute: typeof StaffExtractionIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ask': {
      id: '/ask'
      path: '/ask'
      fullPath: '/ask'
      preLoaderRoute: typeof AskRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/analytics': {
      id: '/admin/analytics'
      path: '/admin/analytics'
      fullPath: '/admin/analytics'
      preLoaderRoute: typeof AdminAnalyticsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/tags': {
      id: '/admin/tags'
      path: '/admin/tags'
      fullPath: '/admin/tags'
      preLoaderRoute: typeof AdminTagsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/admin/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library/': {
      id: '/library/'
      path: '/library'
      fullPath: '/library/'
      preLoaderRoute: typeof LibraryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/library/$documentId': {
      id: '/library/$documentId'
      path: '/library/$documentId'
      fullPath: '/library/$documentId'
      preLoaderRoute: typeof LibraryDocumentIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/questions/': {
      id: '/questions/'
      path: '/questions'
      fullPath: '/questions/'
      preLoaderRoute: typeof QuestionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/questions/$questionId': {
      id: '/questions/$questionId'
      path: '/questions/$questionId'
      fullPath: '/questions/$questionId'
      preLoaderRoute: typeof QuestionsQuestionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/staff/extraction/': {
      id: '/staff/extraction/'
      path: '/staff/extraction'
      fullPath: '/staff/extraction/'
      preLoaderRoute: typeof StaffExtractionIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/staff/extraction/$partnerId': {
      id: '/staff/extraction/$partnerId'
      path: '/staff/extraction/$partnerId'
      fullPath: '/staff/extraction/$partnerId'
      preLoaderRoute: typeof StaffExtractionPartnerIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AskRoute: AskRoute,
  AdminAnalyticsRoute: AdminAnalyticsRoute,
  AdminTagsRoute: AdminTagsRoute,
  AdminUsersRoute: AdminUsersRoute,
  LibraryDocumentIdRoute: LibraryDocumentIdRoute,
  QuestionsQuestionIdRoute: QuestionsQuestionIdRoute,
  LibraryIndexRoute: LibraryIndexRoute,
  QuestionsIndexRoute: QuestionsIndexRoute,
  StaffExtractionPartnerIdRoute: StaffExtractionPartnerIdRoute,
  StaffExtractionIndexRoute: StaffExtractionIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
